export default __webpack_public_path__ + "static/media/popcorn-pieces-09.c84d8116.png";